/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'facebook': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="currentColor" d="M12 3h-2c-.3 0-1 .47-1 1v2h3v3H9v7H6V9H3V6h3V4c0-2.21 1.96-4 4.06-4H12v3z"/>'
  }
})
